var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-slip-validation-details" },
    [
      _c(
        "div",
        { staticClass: "filter-section-container" },
        [
          _c("div", { staticClass: "filter-fixed" }, [
            _c("span", { staticClass: "filter-fixed-title" }, [
              _vm._v(_vm._s(_vm.$t("data.filter_section"))),
            ]),
            _c("i", {
              staticClass: "el-icon-arrow-down filter-fixed-arrow",
              class: { "fiter-icon-arrow-route": !_vm.showFilterContent },
              on: { click: _vm.onClickFixedArrow },
            }),
          ]),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFilterContent,
                    expression: "showFilterContent",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "filter-content",
                    attrs: { id: "filter-content" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value date-picker-long",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                            "picker-options": _vm.$commonFn.dateLimit(this, 31),
                          },
                          model: {
                            value: _vm.search.create_times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "create_times", $$v)
                            },
                            expression: "search.create_times",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("merchantAccount.complete_time"))
                          ),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value date-picker-long",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                            "picker-options": _vm.$commonFn.dateLimit(this, 31),
                          },
                          model: {
                            value: _vm.search.complete_times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "complete_times", $$v)
                            },
                            expression: "search.complete_times",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.mini_qr_raw_content"))),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            type: "text",
                            maxlength: "128",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.mini_qr_raw_content,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "mini_qr_raw_content", $$v)
                            },
                            expression: "search.mini_qr_raw_content",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("data.merchant_request_order_no"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            type: "text",
                            maxlength: "64",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.mch_request_no,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "mch_request_no", $$v)
                            },
                            expression: "search.mch_request_no",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.verification_serial_no"))),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            type: "text",
                            maxlength: "64",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.request_no,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "request_no", $$v)
                            },
                            expression: "search.request_no",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.verification_result"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { size: "small", clearable: "" },
                            model: {
                              value: _vm.search.match_result,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "match_result", $$v)
                              },
                              expression: "search.match_result",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("dashboard.all"),
                                value: "",
                              },
                            }),
                            _vm._l(
                              _vm.verificationResultOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.order_status"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { size: "small", clearable: "" },
                            model: {
                              value: _vm.search.order_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "order_status", $$v)
                              },
                              expression: "search.order_status",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("dashboard.all"),
                                value: "",
                              },
                            }),
                            _vm._l(_vm.orderStatusOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c("div", { staticClass: "filter-operate" }, [
                  _c("div", { staticClass: "filter-operate-left" }),
                  _c(
                    "div",
                    { staticClass: "filter-operate-right" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: { size: "small" },
                          on: { click: _vm.onClickReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.clear")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "mb-10 download-btn",
                          attrs: {
                            loading: _vm.downloading,
                            type: "info",
                            size: "small",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.onClickDowmloadBtn },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.download")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "total-container" }, [
        _c("div", { staticClass: "total-item" }, [
          _vm._v(" " + _vm._s(_vm.$t("data.total_count")) + ": "),
          _c("span", { staticStyle: { color: "#3855F1" } }, [
            _vm._v(_vm._s(_vm.summary.total_count)),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("data.total_payment_slip_validation_fee")) +
              ": "
          ),
          _c("span", { staticStyle: { color: "#3855F1" } }, [
            _vm._v(
              "THB " + _vm._s(_vm._f("toDivideWithDot")(_vm.summary.total_fee))
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.merchant_request_order_no"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.mch_request_no || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.verification_serial_no"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.request_no || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.mini_qr_raw_content"),
                  align: "center",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              content: scope.row.mini_qr_raw_content,
                            },
                          },
                          [
                            _c("span", { staticClass: "show-ellipsis" }, [
                              _vm._v(
                                _vm._s(scope.row.mini_qr_raw_content || "-")
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.transaction_amount_thb"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.bank_trans_amount
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.bank_trans_amount
                                  )
                                )
                              ),
                            ])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.order_status"),
                  align: "center",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getOrderStatusType(
                                scope.row.order_status
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getOrderStatusLabel(scope.row.order_status)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.verification_result"),
                  align: "center",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getVerificationResultType(
                                scope.row.match_result
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getVerificationResultLabel(
                                  scope.row.match_result
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "160",
                  label: _vm.$t("merchantAccount.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.transaction_create_time || "-") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "160",
                  label: _vm.$t("merchantAccount.complete_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.transaction_return_time || "-")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.detail"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailTxt(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("PaymentSlipValidationDetailModal", {
        ref: "paymentSlipValidationDetailModal",
        attrs: { visible: _vm.detailModalVisible },
        on: {
          "update:visible": function ($event) {
            _vm.detailModalVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }